import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'cookie-dialog',
  styleUrls: ['./cookie-dialog.component.scss'],
  templateUrl: 'cookie-dialog.component.html'
})
export class CookieDialog {
    message: string = ""
    acceptButtonText = ""
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<CookieDialog>,
        private translateService: TranslateService,
        private sessionService: SessionService) {
            if (data) {
                this.message = data.message || this.message;
                if (data.buttonText) {
                  this.acceptButtonText = data.buttonText.accept
                }
            }
        }

    onConfirmClick(): void {
        this.sessionService.acceptCookies();
        this.dialogRef.close(true);
    }
}